"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_websocket_1 = require("./lib/use-websocket");
exports.default = use_websocket_1.useWebSocket;
var use_socket_io_1 = require("./lib/use-socket-io");
exports.useSocketIO = use_socket_io_1.useSocketIO;
var constants_1 = require("./lib/constants");
exports.ReadyState = constants_1.ReadyState;
//# sourceMappingURL=index.js.map